import ThankYouComponent from './ThankYouComponent';
import { TEXT } from 'locales/translations';
import { Link } from 'Common';
import { linkHandler } from 'utils/linkHandler';

export const ThankYouUpgrade = () => {
  return (
    <ThankYouComponent title={TEXT.thankYouUpgrade.title} showFooter>
      <Link button className="btn-inverted" to={linkHandler.get('library')}>
        {TEXT.thankYou.btnLibrary}
      </Link>
    </ThankYouComponent>
  );
};

export default ThankYouUpgrade;
